import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})

export class AppComponent implements OnInit {
  title = 'p-app';
  footerVisible = true;
  showAdminLogin = false;
  currentTab: 'home1' | 'home2' = 'home1';
  isHomeRoute = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.checkAdminAccess();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const cleanUrl = event.urlAfterRedirects.split('?')[0].split('#')[0];
        this.isHomeRoute = (cleanUrl === '/' || cleanUrl === '');

        // Hide footer on authentication pages
        const authRoutes = ['/login', '/register', '/otp'];
        this.footerVisible = !authRoutes.includes(cleanUrl);
      }
    });
  }
  changeTab(tab: 'home1' | 'home2') {
    this.currentTab = tab;
  }

  checkAdminAccess() {
    const isAdminSubdomain = window.location.hostname.startsWith('admin.');
    const hasSecret = !!localStorage.getItem('admin-secret');
    this.showAdminLogin = isAdminSubdomain && !hasSecret;
  }

  onLoginSuccess() {
    this.checkAdminAccess();
  }
}
